module.exports = __webpack_public_path__ + "teqbahn-assets/media/gis_bw.c2e62ae9.png";